import { ContainerTypes } from "./containerTypes";

export type TargetItem = {
  id: string;
  type: CopyPasteTypes;
  isScaffold: boolean;
}

export type CopiedItem = {
  id: string;
  type: CopyPasteTypes;
  depth: number;
};

export enum TreeTypes {
  Operation = 'operation',
  Procedure = 'procedure',
  Parameter = 'parameter'
}

export const copyPasteTypes = {
  ...TreeTypes,
  ...ContainerTypes,
};

export type CopyPasteTypes = TreeTypes | ContainerTypes;